// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"48887780","890":"4c3ce4c2","921":"f508cae0"}[chunkId] + ".chunk.js";
};